import Chat from "@/assets/js/chat.js";

let webSocketsService = {}
webSocketsService.install = function (Vue, options) {

  const TIMEOUT = 300000; //Stop event loop after 5 min after user has left view
  const BROADCAST_TYPE={  // Broadcast messages
    CHECKIN:'checkin',
    SOLVE:'solve',
    LEADER_CHANGE:'leaderChange',
    LEADER_CHANGE_REQUEST:'leaderChangeRequest',
    TEAM_PHOTO_CHANGE:'teamPhotoChange',
    TEAM_NAME_CHANGE:'teamNameChange',
    POSITION:'position'
  };

  if (null == options) {
    console.error('Can not start websocket service. Options are not defined');
    return;
  }

  let ws = null;
  let blurPointer=null;
  let self=this;
  let lastLoggedEventId=null;
  this.wsConnect = (token, event_id) => {
    self.destroyWebsocket();
    self.initBackgroundListener();

    ws = new Chat(
      options.server_api,
      options.store,
      () => {
        //Login player
        ws.login(token, event_id);

        //Connected callback
        if (Vue._.isFunction(options.onConnected)) {
          let isReconnect=(lastLoggedEventId!=event_id)?false:true;
          lastLoggedEventId=event_id;
          options.onConnected(event_id,isReconnect);
        }
        
      }
    );

    self.registerListener(ws);
    ws.startWebsockets();
  }

  /* Public methods */
  Vue.prototype.$websocket = {};
  Vue.prototype.$websocket.connect = (token, event_id) => {
    this.wsConnect(token, event_id);
  }

  Vue.prototype.$websocket.disconnect = () => {
    this.destroyWebsocket();
  }

  Vue.prototype.$websocket.destroy = () => {
    this.destroy();
  }

  Vue.prototype.$websocket.client = () => {
    return ws;
  }
  Vue.prototype.$websocket.setCallback = (name,clb) => {
    if(options && Vue._.isString(name)&&Vue._.isFunction(clb)){
      options[name]=clb;
    }
  }

  Vue.prototype.$websocket.broadcast={};
  /* checkin */
  Vue.prototype.$websocket.broadcast[BROADCAST_TYPE.CHECKIN] = (spot_id,open_in_Popup=false) => {
    if(ws){
      ws.broadcast({
        type:BROADCAST_TYPE.CHECKIN,
        spot_id:spot_id,
        open_in_Popup:open_in_Popup
      },false);
    }
  }

  /* Solve */
  Vue.prototype.$websocket.broadcast[BROADCAST_TYPE.SOLVE] = (wp_id,open_in_Popup=false) => {
    if(ws){
      ws.broadcast({
        type:BROADCAST_TYPE.SOLVE,
        wp_id:wp_id,
        open_in_Popup:open_in_Popup
      },false);
    }
  }

  /* Leader change */
  Vue.prototype.$websocket.broadcast[BROADCAST_TYPE.LEADER_CHANGE] = (person_id,agree) => {
    if(ws){
      ws.broadcast({
        type:BROADCAST_TYPE.LEADER_CHANGE,
        leader_id:person_id,
        agree:agree,
      },false);
    }
  }

  /* Request Leader change */
  Vue.prototype.$websocket.broadcast[BROADCAST_TYPE.LEADER_CHANGE_REQUEST] = (person_id,abort=false) => {
    if(ws){
      ws.broadcast({
        type:BROADCAST_TYPE.LEADER_CHANGE_REQUEST,
        leader_id:person_id,
        abort:abort,
        time_utc:new Date().getTime()
      },false);
    }
  }
  
  /* Location update */
  
  // Without battery level
  // Vue.prototype.$websocket.broadcast[BROADCAST_TYPE.POSITION] = (position) => {
  //   if(ws){
  //     let batteryLevel = '';
  //     let jsonMessage = {
  //       lat:position.coords.latitude?position.coords.latitude:'',
  //       lng:position.coords.longitude?position.coords.longitude:'',
  //       alt:position.coords.altitude?position.coords.altitude:'',
  //       speed:position.coords.speed?position.coords.speed:'',
  //       bat:batteryLevel,
  //     };
  //     ws.broadcast(jsonMessage, false, false, 'position');
  //   }
  // }

  // With battery level
  Vue.prototype.$websocket.broadcast[BROADCAST_TYPE.POSITION] = async (position) => {
    if(ws){
      let batteryLevel = '';
      if ('getBattery' in navigator) {
        try {
          const battery = await navigator.getBattery();
          batteryLevel = battery.level * 100;
        } catch (error) {
          console.error('Battery API error:', error);
        }
      }
      let jsonMessage = {
        lat:position.coords.latitude?position.coords.latitude:'',
        lng:position.coords.longitude?position.coords.longitude:'',
        alt:position.coords.altitude?position.coords.altitude:'',
        speed:position.coords.speed?position.coords.speed:'',
        bat:batteryLevel,
      };
      ws.broadcast(jsonMessage, false, false, 'position');
    }
  }

  /* Team photo change */
  Vue.prototype.$websocket.broadcast[BROADCAST_TYPE.TEAM_PHOTO_CHANGE] = (person_id) => {
    if(ws){
      ws.broadcast({
        type:BROADCAST_TYPE.TEAM_PHOTO_CHANGE,
        person_id:person_id
      },false);
    }
  }

   /* Team name change */
   Vue.prototype.$websocket.broadcast[BROADCAST_TYPE.TEAM_NAME_CHANGE] = (person_id) => {
    if(ws){
      ws.broadcast({
        type:BROADCAST_TYPE.TEAM_NAME_CHANGE,
        person_id:person_id
      },false);
    }
  } 

  /* Private methods */

  this.registerListener=function(ws){
    if(ws){
      ws.setErrorClb((key, error)=> {
        console.log(error);
      });

      ws.setOnlineClb((/*teamid, teamname, online, visible, icon*/)=> {

      });

      ws.setTeamClb((/*teamid, teamname, online, visible, icon*/)=> {

      });

      ws.setBroadcastClb((message)=> {
          if(Vue._.isObject(message)){
            switch (message.type) {
              case BROADCAST_TYPE.CHECKIN:
                if (Vue._.isFunction(options.onCheckin)) {
                  let spot_id=(message)?message.spot_id:null;
                  let open_in_Popup=(message)?message.open_in_Popup:false;
                  options.onCheckin(spot_id,open_in_Popup);
                }
              break;
              case BROADCAST_TYPE.SOLVE:
                  if (Vue._.isFunction(options.onSolve)) {
                    let spot_id=(message)?message.wp_id:null;
                    let open_in_Popup=(message)?message.open_in_Popup:false;
                    let event_id=ws?ws.getConnectedEventId():null;
                    options.onSolve(event_id,spot_id,open_in_Popup);
                  }
                break;
              case BROADCAST_TYPE.LEADER_CHANGE:
                  if (Vue._.isFunction(options.onLeaderChange)) {
                    let leader_id=(message)?message.leader_id:null;
                    let agree=(message)?message.agree:null;
                    options.onLeaderChange(leader_id,agree);
                  }
                break;
              case BROADCAST_TYPE.LEADER_CHANGE_REQUEST:
                  if (Vue._.isFunction(options.onLeaderChangeRequest)) {
                    let leader_id=(message)?message.leader_id:null;
                    let time_utc=(message)?message.time_utc:null;
                    let abort=(message)?message.abort:false;
                    options.onLeaderChangeRequest(leader_id,time_utc,abort);
                  }
                break;
                case BROADCAST_TYPE.TEAM_PHOTO_CHANGE:
                  if (Vue._.isFunction(options.onTeamPhotoChange)) {
                    let person_id=(message)?message.person_id:null;
                    options.onTeamPhotoChange(person_id);
                  }
                break;
                case BROADCAST_TYPE.TEAM_NAME_CHANGE:
                  if (Vue._.isFunction(options.onTeamNameChange)) {
                    let person_id=(message)?message.person_id:null;
                    options.onTeamNameChange(person_id);
                  }
                break;

              default:
                console.log('websocket message: ', message);
                break;
          }
        }
      });

      ws.setWebsocketOnlineStateClb((isConnected, lastOnlineTime) =>{
        console.log('WebSocket is connected: ' + isConnected);

        //Delay to prevent a visible ui offline state icon during page refresh
        setTimeout(()=>{
          self._setWebsocketState(isConnected);
        },500);

        //if websocket was interrupted, get fresh data from it
        if (isConnected && lastOnlineTime != null && lastOnlineTime > 0) {

          setTimeout(()=> {
            //TODO - which data to reload
            //ws.sendGetAllMissedChatMessages();
          }, 5000);
        }
      });
    }else{
      console.warn('Can not start websocket because of null pointer');
    }
  }

  this._setWebsocketState=function(isConnected){
    if (options.store) {
      options.store.commit("websocket/SET_ONLINE_STATE", isConnected);
    }
  }

  this.destroyWebsocket = function () {
    if (ws !== null) {
      ws.logout();
      ws.destroy();
      ws.length = 0;
      ws = null;
    }
  }

  this.destroy = function () {
    this.destroyBackgroundListener()
    this.destroyWebsocket();
  }

  this.startWebsocketIfNotRunning=function(){
    if(ws && !ws.isSystemConnected()){
      ws.startWebsockets();
    }
  }

  /* Interruption Security - Loop  */

  /* Message Type sender/receiver */

  /* Store Management */


  /*Tab Management */
  this.onBlur = function() {
    console.log('onBlur websocket');
    if(ws){
      ws.pauseConnection();
    }
  }

  this.onBlurDelayed = function() {
    console.log('onBlurDelayed websocket');

    self.removeOnBlurDelayedTimer();
    self.setOnBlurDelayedTimer();
  }

  this.setOnBlurDelayedTimer=function(){
    blurPointer = setTimeout(() => {
      self.onBlur();
    }, TIMEOUT);
  }

  this.removeOnBlurDelayedTimer=function(){
    if (blurPointer) {
      clearTimeout(blurPointer);
      blurPointer=null;
    }
  }

  this.onFocus = function() {
    console.log('onFocus websocket');

    self.removeOnBlurDelayedTimer();
    self.startWebsocketIfNotRunning();
  }

  this.destroyBackgroundListener = function() {
    window.removeEventListener('focus', self.onFocus);
    window.removeEventListener('blur', self.onBlurDelayed);
  }

  this.initBackgroundListener = function() {
    window.addEventListener('focus', self.onFocus);
    window.addEventListener('blur', self.onBlurDelayed);
  }

}

export default webSocketsService

